import React from 'react';

type AddressDisplayProps = React.HTMLAttributes<HTMLParagraphElement> & { addressLines: string[] };
const AddressDisplay: React.FC<AddressDisplayProps> = ({ addressLines, ...props }) => {
  if (addressLines.length < 1) return null;
  return (
    <p {...props}>
      {addressLines.map((addressline, index) => (
        <span key={index}>
          {addressline} <br />
        </span>
      ))}
    </p>
  );
};

export default AddressDisplay;
